import { DatePicker } from "@mui/x-date-pickers"
import { Controller } from "react-hook-form"
import dayjs from "dayjs"

export default function ControlledDatePicker({
  label,
  name,
  control = null,
  disabled = false,
  openTo = null,
  views = null,
  size = "small",
  variant = "outlined",
  rules = null,
  minDate = null,
  maxDate = null
}) {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={null}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <DatePicker
          {...field}
          disabled={disabled}
          label={label}
          value={dayjs(field.value)}
          onChange={(event) => field.onChange(event ? dayjs(event).format("YYYY-MM-DD") : null)}
          slotProps={{
            textField: {
              fullWidth: true,
              size: size,
              variant: variant,
              error: !!error,
              helperText: error?.message,
            },
          }}
          format='DD/MM/YYYY'
          openTo={openTo}
          views={views}
          minDate={minDate}
          maxDate={maxDate}
        />
      )}
    />
  )
}
